import { useContext } from "react";
import { useReactiveVar } from "@apollo/client";
import { CompanyAccess, PermissionScope } from "@me-team/host/main/graphql/types";
import { currentBranchEmployeeIdVar } from "@me-team/host/main/globalVar/state";
import { AccessContext } from "@me-team/host/src/components/App/App";
import AccessService from "@me-team/host/services/AccessService";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

export const useWarehouseReportsAccess = () => {
    const { isReady: isAccessContextReady } = useContext(AccessContext);
    const accessService = AccessService.getInstance();
    const currentBranchEmployeeId = useReactiveVar(currentBranchEmployeeIdVar);

    const canViewWarehouseReportsAll = useRoleAccess(CompanyAccess.WarehouseReportViewExport, {
        scope: PermissionScope.All,
    });
    const canViewWarehouseReportsSelf = useRoleAccess(CompanyAccess.WarehouseReportViewExport, {
        scope: PermissionScope.Self,
    });

    const canViewWarehouseReports = canViewWarehouseReportsAll || canViewWarehouseReportsSelf;
    const shouldShowOnlyOwnReports = canViewWarehouseReportsSelf && !canViewWarehouseReportsAll;
    const isWarehouseReportsAccessPending =
        !isAccessContextReady || !accessService.isRoleAccessReady() || accessService.isRoleAccessLoading();
    const lockedEmployeeId = shouldShowOnlyOwnReports ? (currentBranchEmployeeId ?? null) : null;

    return {
        canViewWarehouseReportsAll,
        canViewWarehouseReportsSelf,
        canViewWarehouseReports,
        shouldShowOnlyOwnReports,
        isWarehouseReportsAccessPending,
        currentBranchEmployeeId,
        lockedEmployeeId,
    };
};
